import React from 'react';
import { withAuth } from '@okta/okta-react';
import { withAlert } from 'react-alert';
import { CrudForm } from '@westernmilling/eu_react_shared';
export default withAuth(withAlert()(class AddForm extends CrudForm {
  constructor(props) {
    super(props);
    this.formType = () => this.props.title;
    this.getCrudType = () => 'notes';
    this.getLabelColumns = () => 3;
    this.getFieldColumns = () => 7;
    this.successAlertMsg = data => ['Note added successfully', 'success'];
    this.modalBodyRows = () => /*#__PURE__*/React.createElement("div", null, this.getTextareaRow('text', 'Note', true), /*#__PURE__*/React.createElement("br", null));
    this.state.item.model_type = this.props.modelType;
    this.state.item.model_uuid = this.props.modelUuid;
  }
}));